import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import PaymentModal from '../PaymentModal';
import "react-datepicker/dist/react-datepicker.css";
import Button from '../ui/Button';

const BookingForm = () => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  
  const [formData, setFormData] = useState({
    service: 'Massage',
    subservices: [],
    date: new Date(),
    time: '',
    name: '',
    email: '',
    phone: '',
    notes: '',
    paymentType: 'booking',
    referralSource: '',
    previousMassageTherapy: false,
    onMedication: false,
    medicationDetails: '',
    exercising: false,
    exerciseFrequency: '',
    exerciseHours: '',
    healthConditions: [],
    disclaimerAgreed: false
  });

  // Health conditions array
  const healthConditions = [
    'Alcohol within 24hrs',
    'Recent Surgery',
    'Infection',
    'Kidney alignment',
    'Open wounds',
    'Emotional changes',
    'Phlebitis',
    'Chronic pains',
    'Sinus congestion',
    'Bruises',
    'Blood clot',
    'Headaches',
    'High Blood pressure',
    'Fever within 24hrs',
    'Wear contacts',
    'Flu',
    'Acute pain',
    'Grief process',
    'Allergies',
    'Arthritis',
    'Chronic Pain',
    'Diabetes',
    'Varicose Veins',
    'Skin Conditions',
    'Recent Injuries',
    'Pregnancy',
    'Osteoporosis',
    'Cancer',
    'Heart Condition'
  ];

  // Referral sources
  const referralSources = [
    'Social Media',
    'Word of Mouth',
    'Google Search',
    'Flyer/Poster',
    'Friend/Family Recommendation',
    'Other'
  ];


  const serviceData = {
    Massage: {
      subservices: [
        { name: 'Nuru', price: 100000 },
        { name: 'Lingam', price: 50000 },
        { name: 'Soapy/Shower', price: 70000 },
        { name: 'Sleepover Ecstacy', price: 200000 },
        { name: 'Chair Sensual', price: 40000 },
        { name: 'Tantric/Erotic', price: 120000 },
        { name: 'Deep Tissue', price: 30000 },
        { name: 'Hotstone', price: 30000 },
        { name: 'Ashiatsu', price: 20000 },
        { name: 'Back/Neck', price: 20000 },
        { name: 'Swedish', price: 25000 },
      ]
    }
  };

  const availableTimes = [
    '09:00', '10:00', '11:00', '12:00', '13:00', 
    '14:00', '15:00', '16:00', '17:00'
  ];

  const services = [
    'Massage'
  ];

  const handleServiceChange = (e) => {
    setFormData({
      ...formData,
      service: e.target.value,
      subservices: []
    });
    setTotalAmount(0);
  };

  const handleSubserviceChange = (subservice) => {
    const updatedSubservices = formData.subservices.includes(subservice.name)
      ? formData.subservices.filter(name => name !== subservice.name)
      : [...formData.subservices, subservice.name];
    
    setFormData({
      ...formData,
      subservices: updatedSubservices
    });

    // Calculate total amount
    const total = serviceData[formData.service].subservices
      .filter(service => updatedSubservices.includes(service.name))
      .reduce((sum, service) => sum + service.price, 0);
    
    setTotalAmount(total);
  };

  // Select/Unselect health conditions
  const handleHealthConditionChange = (condition) => {
    const updatedConditions = formData.healthConditions.includes(condition)
      ? formData.healthConditions.filter(c => c !== condition)
      : [...formData.healthConditions, condition];
    
    setFormData({
      ...formData,
      healthConditions: updatedConditions
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.subservices.length === 0) {
      alert('Please select at least one service option');
      return;
    }

    if (!formData.disclaimerAgreed) {
      alert('Please agree to the disclaimer');
      return;
    }

    setShowPaymentModal(true);
  };


  return (
    <div className="w-full max-w-2xl mx-auto p-4 md:p-6 bg-secondary rounded-lg shadow-lg font-body">
      <h2 className="text-xl md:text-2xl font-body font-bold mb-4 md:mb-6 text-center">CLIENT FORM</h2>
      
      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
        {/* Client Bio */}
        <div className="bg-secondary-light p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Bio <span className='text-red-500 text-base'>*</span>
          </h3>
          <div className='space-y-3'>
            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Full Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Phone</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              />
            </div>
          </div>
        </div>
        
        {/* Booking Information */}
        <div className="bg-secondary-light p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Booking Information <span className='text-red-500 text-base'>*</span>
          </h3>
          <div className='space-y-3'>
            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Select Service</label>
              <select
                value={formData.service}
                onChange={handleServiceChange}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              >
                <option value="">Select a service</option>
                {services.map((service, index) => (
                  <option key={index} value={service}>{service}</option>
                ))}
              </select>
            </div>

            <hr className='border-transparent my-3 md:my-4'/>

            {formData.service && (
              <div>
                <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">
                  Select Type of {formData.service}
                </label>
                <hr className='border-dim-dark mb-2 md:mb-3'/>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
                  {serviceData[formData.service].subservices.map((subservice, index) => (
                    <div key={index} className="flex items-start space-x-2 p-2 bg-white rounded">
                      <input
                        type="checkbox"
                        id={`service-${index}`}
                        checked={formData.subservices.includes(subservice.name)}
                        onChange={() => handleSubserviceChange(subservice)}
                        className="mt-1"
                      />
                      <label htmlFor={`service-${index}`} className="text-sm md:text-base">
                        {subservice.name}
                        <div className="text-gray-600 text-sm">₦{subservice.price.toLocaleString()}</div>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Choose a Date</label>
              <DatePicker
                selected={formData.date}
                onChange={(date) => setFormData({...formData, date})}
                minDate={new Date()}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">Select Time</label>
              <select
                value={formData.time}
                onChange={(e) => setFormData({...formData, time: e.target.value})}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                required
              >
                <option value="">Select a time</option>
                {availableTimes.map((time) => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Background Information */}
        <div className="bg-gray-100 p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">Background Information</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-1 md:mb-2 text-sm md:text-base">
                How did you learn about us?
              </label>
              <select
                value={formData.referralSource}
                onChange={(e) => setFormData({...formData, referralSource: e.target.value})}
                className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
              >
                <option value="">Select a source</option>
                {referralSources.map((source) => (
                  <option key={source} value={source}>{source}</option>
                ))}
              </select>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="previous-massage"
                checked={formData.previousMassageTherapy}
                onChange={() => setFormData({
                  ...formData, 
                  previousMassageTherapy: !formData.previousMassageTherapy
                })}
                className="mr-2"
              />
              <label htmlFor="previous-massage" className="text-sm md:text-base">
                Have you received massage therapy or bodywork before?
              </label>
            </div>

            <div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="on-medication"
                  checked={formData.onMedication}
                  onChange={() => setFormData({
                    ...formData, 
                    onMedication: !formData.onMedication
                  })}
                  className="mr-2"
                />
                <label htmlFor="on-medication" className="text-sm md:text-base">
                  Are you on any medication?
                </label>
              </div>
              {formData.onMedication && (
                <input
                  type="text"
                  value={formData.medicationDetails}
                  onChange={(e) => setFormData({...formData, medicationDetails: e.target.value})}
                  placeholder="Please specify medications"
                  className="w-full p-2 md:p-3 mt-2 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                />
              )}
            </div>

            <div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="exercising"
                  checked={formData.exercising}
                  onChange={() => setFormData({
                    ...formData, 
                    exercising: !formData.exercising
                  })}
                  className="mr-2"
                />
                <label htmlFor="exercising" className="text-sm md:text-base">
                  Do you exercise?
                </label>
              </div>
              {formData.exercising && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-4 mt-2">
                  <input
                    type="number"
                    value={formData.exerciseFrequency}
                    onChange={(e) => setFormData({...formData, exerciseFrequency: e.target.value})}
                    placeholder="Times per week"
                    className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                  />
                  <input
                    type="number"
                    value={formData.exerciseHours}
                    onChange={(e) => setFormData({...formData, exerciseHours: e.target.value})}
                    placeholder="Hours per week"
                    className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 text-sm md:text-base"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Health Conditions */}
        <div className="bg-gray-100 p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Please mark any of the following conditions you may currently have
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
            {healthConditions.map((condition, index) => (
              <div key={index} className="flex items-start space-x-2 p-2 bg-white rounded">
                <input
                  type="checkbox"
                  id={`condition-${condition}`}
                  checked={formData.healthConditions.includes(condition)}
                  onChange={() => handleHealthConditionChange(condition)}
                  className="mt-1"
                />
                <label htmlFor={`condition-${condition}`} className="text-sm md:text-base">
                  {condition}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Notes */}
        <div className="bg-secondary-light p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Additional Notes <span className='text-sm italic text-dim-dark'>(optional)</span>
          </h3>
          <textarea
            value={formData.notes}
            onChange={(e) => setFormData({...formData, notes: e.target.value})}
            className="w-full p-2 md:p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 h-24 md:h-32 text-sm md:text-base"
          />
        </div>

        {/* Disclaimer */}
        <div className="bg-accent-lighter p-3 md:p-4 rounded-lg">
          <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Disclaimer <span className='text-red-500 text-base'>*</span>
          </h3>
          <div className="flex items-start space-x-2">
            <input
              type="checkbox"
              id="disclaimer"
              checked={formData.disclaimerAgreed}
              onChange={() => setFormData({
                ...formData, 
                disclaimerAgreed: !formData.disclaimerAgreed
              })}
              className="mt-1"
              required
            />
            <label htmlFor="disclaimer" className="text-sm md:text-base text-justify font-lato">
              I understand that massage therapy is for the purpose of stress reduction, 
              relief from muscular tension or spasm, or for increasing circulation. 
              I understand that the massage therapist does not diagnose illness, disease 
              or any other physical or mental disorder. The massage therapist does not 
              prescribe medical treatment nor perform spinal manipulations. I will 
              inform the therapist of any current condition at the time of each visit.
            </label>
          </div>
        </div>

        {/* Total Amount */}
        {totalAmount > 0 && (
          <div className="text-right text-base md:text-lg font-bold">
            Total: ₦{totalAmount.toLocaleString()}
          </div>
        )}

        {/* Submit Button */}
        <Button
          type="submit"
          variant='accent'
          className="w-full text-white py-2 md:py-3 rounded-lg text-sm md:text-base"
        >
          Confirm Booking
        </Button>
      </form>

        {/* Payment popup */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        amount={totalAmount}
        customerName={formData.name}
        customerEmail={formData.email}
        customerPhone={formData.phone}
        bookingDetails={{
          service: formData.service,
          subservices: formData.subservices,
          appointmentDate: formData.date,
          appointmentTime: formData.time,
          notes: formData.notes,
          paymentType: formData.paymentType,
          referralSource: formData.referralSource,
          previousMassageTherapy: formData.previousMassageTherapy,
          onMedication: formData.onMedication,
          medicationDetails: formData.medicationDetails,
          exercising: formData.exercising,
          exerciseFrequency: formData.exerciseFrequency,
          exerciseHours: formData.exerciseHours,
          healthConditions: formData.healthConditions,
          disclaimerAgreed: formData.disclaimerAgreed
        }}
      />  
    </div>
  );
};

export default BookingForm;